import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

import { Action, Selector, State, StateContext, StateToken } from '@ngxs/store';

import {
  RemoveStudentSessionAction,
  SetStudentSessionAction
} from './student-session.action';

export interface StudentSessionStateModel {
  id: number | null;
  name: string | null;
  pass: string | null;
  token: string | null;
}

export const STUDENT_SESSION_TOKEN = new StateToken<StudentSessionStateModel>(
  'student_session'
);

const initialState = {
  id: null,
  name: null,
  pass: null,
  token: null
};

@State<StudentSessionStateModel>({
  name: STUDENT_SESSION_TOKEN,
  defaults: initialState
})
@Injectable()
export class StudentSessionState {
  private readonly router = inject(Router);

  @Selector() static token({ token }: StudentSessionStateModel) {
    return token;
  }

  @Selector() static student({ id, pass, name }: StudentSessionStateModel) {
    return { id, pass, name };
  }

  @Selector() static pass({ pass }: StudentSessionStateModel) {
    return pass;
  }

  @Action(SetStudentSessionAction) setStudentSession(
    { patchState }: StateContext<StudentSessionStateModel>,
    { payload }: SetStudentSessionAction
  ) {
    patchState({
      id: payload.id,
      name: payload.name,
      token: payload.token,
      pass: payload.pass
    });
  }

  @Action(RemoveStudentSessionAction) removeStudentSession(
    { patchState }: StateContext<StudentSessionStateModel>,
    { payload }: RemoveStudentSessionAction
  ) {
    patchState(initialState);

    if (payload.redirect !== 'none') {
      this.router.navigateByUrl(payload.redirect || '/buscar-aluno', {
        replaceUrl: true
      });
    }
  }
}
